import classNames from 'classnames';
import { forwardRef } from 'react';
export const tabCss = "tvxcthk";
export const headerCss = "h1yev4xe";
export const sectionCss = "s1gul67g";
export const sectionDividerCss = "s1xedecj";
export const subsectionCss = "s16f6be3";
export const subsectionHeaderCss = "suzb2b";
export const typeOptionsCss = "t5nesep";
export const linkListCss = "lw2dom4";
export const addLinkButtonCss = "a48284g";
export const addLinkButtonContentCss = "a176tj8u";
export const addLinkButtonTextCss = "aq83mi9";
const switchToggleLabelCss = "shyeozh";
export const SwitchToggleLabel = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'label';
  return <Component ref={ref} {...restProps} className={classNames(switchToggleLabelCss, props.className)} />;
});
const dragHandleCss = "d1nkacaq";
export const DragHandle = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(dragHandleCss, props.className)} />;
});
export const linkCardContentCss = "lxrragm";
const typeOptionLabelCss = "tqm5q3v";
export const TypeOptionLabel = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'label';
  return <Component ref={ref} {...restProps} className={classNames(typeOptionLabelCss, props.className)} />;
});
const cardIsDraggingCss = "camxcpf";
const collapsedCardCss = "c1h8gd0";
export const CollapsedCard = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    isDragging,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(collapsedCardCss, {
    [cardIsDraggingCss]: isDragging
  }, props.className)} />;
});
const expandedCardCss = "e1a1284e";
export const ExpandedCard = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    isDragging,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(expandedCardCss, {
    [cardIsDraggingCss]: isDragging
  }, props.className)} />;
});
const expandedCardHeaderCss = "e5y98e4";
export const ExpandedCardHeader = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(expandedCardHeaderCss, props.className)} />;
});
const expandedCardBodyCss = "eb3070a";
export const ExpandedCardBody = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(expandedCardBodyCss, props.className)} />;
});
const expandedCardFooterCss = "e7kqpu2";
export const ExpandedCardFooter = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(expandedCardFooterCss, props.className)} />;
});
const cardIconWrapperCss = "c15si5ke";
export const CardIconWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(cardIconWrapperCss, props.className)} />;
});
const cardContentCss = "c2ph6x5";
export const CardContent = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(cardContentCss, props.className)} />;
});
const cardActionsCss = "c1ye8fv0";
export const CardActions = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(cardActionsCss, props.className)} />;
});

require("./styles.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");